import {createContext, useContext} from 'react';

/**
 * Provides the current margin rail display mode.
 * "full" — default expanded rail (336px wide, full cards)
 * "icon" — collapsed icon-only strip (48px wide, icon circles only)
 */
const RailModeContext = createContext('full');

export default RailModeContext;

export function useRailMode() {
    return useContext(RailModeContext);
}
